// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2zsx2","row":"styles_row__nPPnW"};